import { Controller } from "@hotwired/stimulus"

// Result Summary modal (Mission/Campaign show pages, card-less tweak) --
// Jay: "clicking this should open a MODAL that shows the mission summary"
// (supersedes an earlier link/redirect version of this trigger). Mirrors
// survey-preview-modal's open/close/spinner shape, but the fetch is a POST
// that regenerates the MissionResultSummary::Generate Document server-side
// (a real job, not instant) and returns its blob URL as JSON, rather than
// an HTML fragment fetched via GET.
//
// The generated summary is a FULL standalone HTML document
// (<!DOCTYPE html><html>...</html>) -- it cannot be injected via innerHTML
// like survey-preview-modal's partial (nested html/head/body tags are
// invalid there). Instead this builds an <iframe src="..."> pointed at the
// blob URL, exactly like documents/show.html.erb's own inline HTML viewer.
export default class extends Controller {
  static targets = ["dialog", "body"]
  static values = { url: String }

  open() {
    this.bodyTarget.innerHTML = this.spinnerHTML
    this.dialogTarget.showModal()
    this.generate()
  }

  close() {
    this.dialogTarget.close()
    this.bodyTarget.innerHTML = ""
  }

  generate() {
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": this._csrfToken(),
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`result summary generation failed: ${response.status}`)
        return response.json()
      })
      .then((data) => {
        const iframe = document.createElement("iframe")
        iframe.src = data.url
        iframe.className = "w-full h-full"
        iframe.setAttribute("sandbox", "allow-scripts allow-popups allow-same-origin")
        iframe.setAttribute("loading", "lazy")

        this.bodyTarget.innerHTML = ""
        this.bodyTarget.appendChild(iframe)
      })
      .catch(() => {
        this.bodyTarget.innerHTML = this.errorHTML
      })
  }

  get spinnerHTML() {
    return `<div class="flex items-center justify-center h-24">
      <svg class="animate-spin h-6 w-6 text-sapphire" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
      </svg>
    </div>`
  }

  get errorHTML() {
    return `<div class="flex items-center justify-center h-24 text-sm text-red-600">
      Failed to generate the result summary. Please try again.
    </div>`
  }

  _csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
